import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import ClassInterface from "../class_interface/ClassInterface";
import Button from "../../components/Button";
import ExitButton from "../../components/ExitButton";

const SelectClass = ({successHandler}) => {
    const {auth, setAuth} = useAuth();
    const [classes, setClasses] = useState([]);
    const [course, setCourse] = useState("");

    const getClasses = async () => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/users/classes`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }
        });
        if (response.ok) {
            const json = await response.json();
            setClasses(json);
        }
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
        }
    }

    useEffect(() => {getClasses()}, [course]);

    if (course !== "") {
        return <ClassInterface successHandler={(state) => setCourse(state)} course={course}/>
    }

    return <div>
        <ExitButton func={()=> {successHandler(false)}} />
        <div className="flex flex-col">
            <b>Select a class</b>
            <div className="flex flex-col border border-4">
                {classes.map(course => {
                    return <Button text={course} func={() => setCourse(course)} />
                })}
            </div>
        </div>
    </div>
}

export default SelectClass;